var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[(_vm.flag)?_c('m_header'):_c('p_header')],1)}
var staticRenderFns = []

export { render, staticRenderFns }